export default __webpack_public_path__ + "static/media/section2_9.f4bd8167.png";